<template>
  <div class="payment-box">
    <!-- <div class="payment-top">
      <div class="waiting-text"><img src="../../assets/index/clock_icon.png" alt=""> 等待付款</div>
      <div class="order-price">还需支付{{price}}元</div>
      <div class="order-time">请在&nbsp;&nbsp;<span class="time-style">30分钟</span>&nbsp;&nbsp;内完成支付</div>
    </div>
    <div class="payment-type">支付方式</div>
    <div class="wx-pay" @click="wxPayEvent"><img src="../../assets/index/wx_icon.png" alt=""> 微信支付</div>
    <div class="ali-pay" @click="aliPayEvent"><img src="../../assets/index/ali_icon.png" alt=""> 支付宝支付</div>
    <div class="goback-page" @click="$router.push('/myorders/0')">
      <van-icon name="arrow-left" />
    </div> -->
    <img src="@/assets/index/payment_eq_wx.png" v-if="showErcode =='wx'" alt="" class="payment-style" srcset="">
    <img src="@/assets/index/payment_eq_zfb.png" v-else alt="" class="payment-style" srcset="">
    <van-row class="payment-btn">
      <van-col span="12" @click="showErcode  ='wx'" :class="showErcode=='wx' ? 'selected' :''">微信</van-col>
      <van-col span="12" @click="showErcode  ='zfb'" :class="showErcode=='zfb' ? 'selected' :''">支付宝</van-col>
    </van-row>

  </div>

</template>

<script>
import { webPay, aliPay } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "payment",

  data() {
    return {
      showErcode: "wx",
      orderId: this.$route.query.orderId,
      price: this.$route.query.price,
      canSet: false,
    };
  },

  methods: {
    aliPayEvent() {
      sessionStorage.setItem("paynum", this.orderId);
      sessionStorage.setItem("paytype", "ali");
      sessionStorage.setItem("orderPrice", this.$route.query.price);
      let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
      if (ua.indexOf("micromessenger") >= 0) {
        alert("微信");
      } else {
        aliPay(this.orderId).then((res) => {
          console.log(JSON.stringify(res));
          // this.$store.state.user.payUrl = res.info
          // Vue中使用支付宝支付流程:点击支付宝支付调用后台接口，后台会返回一个form表单，只要在Vue里面创建新节点提交就可以唤起支付宝支付了
          const div = document.createElement("div");
          div.innerHTML = res.data; // 此处就是后台返回接到from表单的数据
          document.body.appendChild(div);
          document.forms[0].submit();
        });
      }
    },

    wxPayEvent() {
      sessionStorage.setItem("paynum", this.orderId);
      sessionStorage.setItem("paytype", "wx");

      let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
      if (ua.indexOf("micromessenger") >= 0) {
        alert("微信浏览器");
      } else {
        webPay(this.orderId).then((result) => {
          console.log(result);
          if (result.data.errno == 0) {
            this.canSet = true;

            window.location.replace(
              result.data.data.mweb_url +
                "&redirect_url=" +
                "http%3a%2f%2fcruitaly.cafewallet.cn%2f%23%2ftype%2fresult%3fordertype%3dwx"
            );
          } else {
            Dialog.alert({
              title: "提示",
              message: result.data.errmsg,
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-style {
  width: 60%;
  display: block;
  margin: 70px auto 0;
}
.payment-btn {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  width: 100%;
  .selected {
    color: #d6be93;
  }
  div {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    border: 1px solid #eee;
  }
  div:last-child {
    border-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/type/newPayment.vue